import Editor from "../../Components/common/Editor";
import trans from "./../../../Languages/Languages";
import { useState, useEffect } from "react";
import { Button, Card, message } from "antd";
import API from "../../../API";
import { useLocation } from "react-router";

const TuitionFees = () => {
  message.config({ top: 80 });

  const [tuitionFeeEditorHtml, setTuitionFeeEditorHtml] = useState("");
  const [currentRateEditorHtml, setCurrentRateEditorHtml] = useState("");
  const [scholarShipEditorHtml, setScholarShipEditorHtml] = useState("");
  const [loading, setLoading] = useState(false);

  const [pageData, setPageData] = useState(null);
  const [currentRatesLabel, setCurrentRatesLabel] = useState(null);
  const [scholarshipEntitlementLabel, setScholarshipEntitlementLabel] = useState(null);

  const [renamingSection, setRenamingSection] = useState(null);
  const [editingSection, setEditingSection] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });

  const [feeDegreeData, setFeeDegreeData] = useState();

  const currentDegreeID = window.location.hash.split("/")[3];
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    API.get(`/admin/get/degree/fee/${currentDegreeID}`)
      .then((res) => {
        setPageData(res.data.tuitionFeesLabel);
        setRenameValue(res.data.tuitionFeesLabel?.title);
        setCurrentRatesLabel(res.data.currentRatesLabel);
        setScholarshipEntitlementLabel(res.data.scholarshipEntitlementLabel);

        setFeeDegreeData(res.data?.fee.scholarship_entitlement);
        setTuitionFeeEditorHtml(res.data?.fee.tution_fee);
        setCurrentRateEditorHtml(res.data?.fee.current_rates);
        setScholarShipEditorHtml(res.data?.fee.scholarship_entitlement);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [currentDegreeID, location]);

  const handleSaveSection = async () => {
    const formData = new FormData();
    formData.append("onlinedegree_id", currentDegreeID);
    formData.append("tution_fee", tuitionFeeEditorHtml);
    formData.append("current_rates", currentRateEditorHtml);
    formData.append("scholarship_entitlement", scholarShipEditorHtml);

    try {
      await API.post(`/admin/degree/fee/update/${currentDegreeID}`, formData);
      message.success("Saved Successfully", 3);
      setLoading(false);
    } catch {
      message.error("Something went wrong, please try again", 3);
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setShowContextMenu(false);
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleRenameSubmit = async () => {
    const section = editingSection;
    const page =
      section === "tuition"
        ? pageData
        : section === "rates"
        ? currentRatesLabel
        : scholarshipEntitlementLabel;

    try {
      await API.put(`/admin/pages/slug/${page.slug}`, { title: renameValue });

      if (section === "tuition") {
        setPageData((prev) => ({ ...prev, title: renameValue }));
      } else if (section === "rates") {
        setCurrentRatesLabel((prev) => ({ ...prev, title: renameValue }));
      } else if (section === "scholarship") {
        setScholarshipEntitlementLabel((prev) => ({ ...prev, title: renameValue }));
      }

      setRenamingSection(null);
      setEditingSection(null);
    } catch {
      message.error("Rename failed");
    }
  };

  const handleTitleRightClick = (e, sectionKey, label) => {
    e.preventDefault();
    setContextMenuPos({ x: e.clientX, y: e.clientY });
    setShowContextMenu(true);
    setEditingSection(sectionKey);
    setRenameValue(label?.title);
  };

  const handleTitleDoubleClick = (sectionKey, label) => {
    setRenamingSection(sectionKey);
    setRenameValue(label?.title);
    setEditingSection(sectionKey);
  };

  const renderEditableTitle = (sectionKey, label, fallbackText) => (
    <div
      className="fw-600 fw-15 mb-2"
      onDoubleClick={() => handleTitleDoubleClick(sectionKey, label)}
      onContextMenu={(e) => handleTitleRightClick(e, sectionKey, label)}
    >
      {renamingSection === sectionKey ? (
        <input
          type="text"
          value={renameValue}
          autoFocus
          onChange={(e) => setRenameValue(e.target.value)}
          onBlur={handleRenameSubmit}
          onKeyDown={(e) => e.key === "Enter" && handleRenameSubmit()}
          style={{ padding: "2px 6px", fontSize: "14px" }}
        />
      ) : (
        label?.title || fallbackText
      )}
    </div>
  );

  return (
    <Card loading={loading} bordered={false} style={{ minHeight: 600 }}>
      <div className="pages-container">
        <div className="content-wrapper">
          {/* Tuition Fees */}
          <div className="bg-content-container mb-0" style={{ position: "relative" }}>
            {renderEditableTitle("tuition", pageData, "Tuition Fees")}

            <Editor
              key="tuition"
              editorHtml={tuitionFeeEditorHtml}
              setEditorHtml={setTuitionFeeEditorHtml}
              handleChange={(html) => setTuitionFeeEditorHtml(html)}
            />
          </div>

          {/* Current Rates */}
          <div className="bg-content-container mb-0" style={{ position: "relative" }}>
            {renderEditableTitle("rates", currentRatesLabel, trans.CurrentRates)}

            <Editor
              key="rate"
              editorHtml={currentRateEditorHtml}
              setEditorHtml={setCurrentRateEditorHtml}
              handleChange={(html) => setCurrentRateEditorHtml(html)}
            />
          </div>

          {/* Scholarship Entitlement */}
          <div className="bg-content-container mb-0" style={{ position: "relative" }}>
            {renderEditableTitle("scholarship", scholarshipEntitlementLabel, trans.ScholarshipEntitlement)}

            <Editor
              key="scholarship"
              editorHtml={scholarShipEditorHtml}
              setEditorHtml={setScholarShipEditorHtml}
              handleChange={(html) => setScholarShipEditorHtml(html)}
            />
          </div>
        </div>

        {/* Save Button */}
        <Button
          onClick={handleSaveSection}
          className="btn-save-changes"
          type="primary"
          htmlType="submit"
        >
          {trans.Save}
        </Button>

        {/* Context Menu */}
        {showContextMenu && (
          <ul
            style={{
              position: "fixed",
              top: contextMenuPos.y,
              left: contextMenuPos.x,
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: 4,
              listStyle: "none",
              padding: "5px 10px",
              margin: 0,
              zIndex: 1000,
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
            onClick={() => {
              setRenamingSection(editingSection);
              setShowContextMenu(false);
            }}
            onMouseLeave={() => setShowContextMenu(false)}
          >
            <li>{trans.Rename}</li>
          </ul>
        )}
      </div>
    </Card>
  );
};

export default TuitionFees;
